import type { FC } from 'react'
import { useRef, useState } from 'react'

import { Swipeable } from '@skytech/ui'

import { useAppContext } from '@/app/index.context'
import { useOnClickOutside } from '@/hooks/useOnClickOutside'

import MobileSideBar from './MobileSideBar'

import './burger-menu.scss'

const BurgerMenu: FC = () => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false)
  const menuRef = useRef(null)
  const isBottomMenuPresent = useAppContext().isWizardMode

  useOnClickOutside(menuRef, () => setIsMenuExpanded(false))

  return (
    <Swipeable onSwipedRight={() => setIsMenuExpanded(false)}>
      <div ref={menuRef} className="side-bar">
        <div className={`burger-menu ${isMenuExpanded ? 'isExpanded' : ''}`}>
          <MobileSideBar onBarClose={() => setIsMenuExpanded(false)} />
        </div>

        <button
          className={`burger ${isMenuExpanded ? 'isExpanded' : ''} ${
            isBottomMenuPresent ? 'is-super-small' : ''
          }`}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            setIsMenuExpanded(!isMenuExpanded)
          }}
        >
          <div className="burger-content">
            <div className="burger-line" />
            <div className="burger-line" />
            <div className="burger-line" />
          </div>
        </button>
      </div>
    </Swipeable>
  )
}

export default BurgerMenu
